module.exports = __webpack_public_path__ + "assets/b104.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b104.png
// module id = 575
// module chunks = 0